import { render, staticRenderFns } from "./addProductSpec.vue?vue&type=template&id=45d10a1d&scoped=true"
import script from "./addProductSpec.vue?vue&type=script&lang=js"
export * from "./addProductSpec.vue?vue&type=script&lang=js"
import style0 from "./addProductSpec.vue?vue&type=style&index=0&id=45d10a1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d10a1d",
  null
  
)

export default component.exports